
import axios from 'axios'
import { Toast } from 'antd-mobile'
import {
  getStorage,
  setStorage,
  urlParams,
  getQueryString
} from '@/utils/common'
import { openRecruit } from '@/utils/appAgreement'
import { bdCommonTrack } from '@/utils/bdCourier'
import { getOSType, isInNative } from '@/utils/IssJsBridgeCourier/utils'
import { setUploadImgToken } from '@flashex-fe/courier-utils'
// import {isInNative} from '@/utils/IssJsBridgeCourier/utils'
import { EOSType } from '@/utils/IssJsBridgeCourier/consts'
import IssJsBridgeCourier from '@/utils/IssJsBridgeCourier'
import Moment from 'moment'
const ErrorUrl = '/courierView/NetworkError'
const Axios = axios.create()
const version = urlParams().version || getStorage('version') || getQueryString('version')
const versionname = urlParams().versionname || getStorage('versionname')
const apiVersion =
  urlParams().apiVersion || getStorage('apiVersion') || 'v10'
let token = urlParams().token || getStorage('token') || ''
const issFrom = getQueryString('iss_from') || getStorage('iss_from') || ''
const cityId = getQueryString('cityId') || getStorage('cityId') || ''
const courierId = getQueryString('courierId') || getStorage('courierId') || ''
/* eslint-disable no-new */
new IssJsBridgeCourier(this)
if (token) {
  setStorage('token', token)
} else {
  // token为空埋点
  bdCommonTrack('page_NoToken_h5', {
    href: window.location.href,
    resp_time: new Date().valueOf(),
    userAgent: window.navigator.userAgent
  })
}
if (cityId) {
  setStorage('cityId', cityId)
}
if (issFrom) {
  setStorage('iss_from', issFrom)
}
if (courierId) {
  setStorage('courierId', courierId)
}
if (version) {
  setStorage('version', version)
}
if (versionname) {
  setStorage('versionname', versionname)
}
if (apiVersion) {
  setStorage('apiVersion', apiVersion)
}

const DEFAULT_HEAERS = {
  'Client-Id': 'iss_courier'
}
export enum HTTP_CODE {
  success = 200
}
export enum BIZ_CODE {
  // 601, token为空
  tokenNot = 601,
  // 602, "您目前登录已过期，请重新登录"
  tokenExpired = 602,
  // 603, "该账号已于其他设备登录，请重新登录"
  tokenOtherDeviceLogin = 603,
  // 604, "token已失效，请重新登录"
  tokenFailure = 604,
  tokenFailureNew = 100105,
  tokenFailureEditPassword = 100111,
  tokenChangeDevice = 100109,
  ACCESS_TOKENFailure = 100203,
  ERR_INVALID_TOKEN_SINGLE_LOGIN = 100110,
  //   tokenBraekOffFailure = 12037,
  // 招募状态非法
  recruitStatusInvalid = 501
}
let requestInfo = {}
let reqTime = 0
const apiResponseH5 = (res: any, obj: object, http_err_code?: any, http_err_msg?: any) => {
  bdCommonTrack('api_response_h5', {
    href: window.location.href,
    path: obj.url,
    params: JSON.stringify(obj.params),
    response: JSON.stringify(res ? res.data : {}),
    resp_time: new Date().valueOf(),
    token: token,
    userAgent: window.navigator.userAgent,
    err_code: res ? res.data.status : -2,
    req_time: reqTime,
    time_delta: new Date().valueOf() - reqTime,
    req_time_format: Moment(reqTime).format('YYYY-MM-DD HH:mm:ss'),
    resp_time_format: Moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
    http_err_code: http_err_code,
    http_err_msg: http_err_msg
  })
}
const getTokenFromJsBridge = (tokenData, time) => {
  bdCommonTrack('app_NoToken_h5', {
    href: window.location.href,
    resp_time: new Date().valueOf(),
    isGetTokenFromApp: !!tokenData,
    userAgent: window.navigator.userAgent
  })
}

// 添加请求拦截器
Axios.interceptors.request.use(
  async (config) => {
    reqTime = new Date().valueOf()
    if (!token && isInNative() && (issFrom === 'android_ssy' || issFrom === 'ios_ssy')) {
      // 如果URL没获取到token再通过端内同步协议去获取一下
      let tokenFromJsBridge: any = ''
      if (getOSType() === EOSType.android && window.IssJsBridgeCourier) {
        tokenFromJsBridge = await window.IssJsBridgeCourier.getTokenSync()
        getTokenFromJsBridge(tokenFromJsBridge, reqTime)
      }
      if (getOSType() === EOSType.ios && window.prompt) {
        tokenFromJsBridge = await window.prompt('getTokenSync')
        getTokenFromJsBridge(tokenFromJsBridge, reqTime)
      }
      if (tokenFromJsBridge) {
        token = tokenFromJsBridge
        setStorage('token', token)
      }
    }
    // 在发送请求之前做些什么
    const defaultCfg = {
      // headers: {
      //     'Content-Type': 'application/x-www-form-urlencoded',
      //     'beidou': ''
      // }
    }
    // @ts-expect-error
    const spitStr = config.url.includes('?') ? '&' : '?'
    config.url =
      `${config.url}` +
      `${spitStr}` +
      `token=${token}&version=${version}&versionname=${versionname}&apiVersion=${apiVersion}&iss_from=${issFrom}`
    const requestConfig = {
      ...defaultCfg,
      ...config
    }
    requestInfo = requestConfig
    return requestConfig
  },
  async error => {
    // 对请求错误做些什么
    return await Promise.reject(error)
  }
)

// 添加响应拦截器
Axios.interceptors.response.use(
  (response) => {
    if (
      [
        BIZ_CODE.tokenExpired,
        BIZ_CODE.tokenOtherDeviceLogin,
        BIZ_CODE.tokenFailure,
        BIZ_CODE.tokenNot,
        BIZ_CODE.ACCESS_TOKENFailure,
        BIZ_CODE.ERR_INVALID_TOKEN_SINGLE_LOGIN,
        BIZ_CODE.tokenFailureNew,
        BIZ_CODE.tokenFailureEditPassword,
        BIZ_CODE.tokenChangeDevice
      ].includes(response.data.status)
    ) {
      const outTimer = setTimeout(() => {
        console.log(version, getOSType() === EOSType.android &&
        version >= 549 || getOSType() === EOSType.ios && version >= 649, this.IssJsBridgeCourier.checkToken, 'this.IssJsBridgeCourier.checkTokenthis.IssJsBridgeCourier.checkToken')
        if (getOSType() === EOSType.android &&
        version >= 549 || getOSType() === EOSType.ios && version >= 649) {
          this.IssJsBridgeCourier.checkToken({
            params: {},
            onSuccess: async res => {

            },
            onFail: res => {
              const data = typeof res === 'string' ? JSON.parse(res) : res
              Toast.info(data.errMsg)
            },
            onFinally: res => {

            }
          })
        } else {
          window.location.href = 'shansongyuan://Logout/'
        }
        apiResponseH5(response, requestInfo)
        clearTimeout(outTimer)
      }, 2000)
    }
    // 招募状态异常，跳到招募分发页
    if (response.data.status === BIZ_CODE.recruitStatusInvalid) {
      const openTimer = setTimeout(() => {
        openRecruit()
        clearTimeout(openTimer)
      }, 2000)
      return response
    }

    if (response.data.status === 200 || response.data.status === 'OK') {
      try {
        const resData =
          typeof response.data.data === 'string' &&
          response.data.data.indexOf('{') > -1 &&
          JSON.parse(response.data.data)
        if (typeof resData === 'object' && resData) {
          // 针对里层的数据格式Error时给出Msg提示
          if (typeof resData.Error === 'number' && resData.Error !== 0) {
            Toast.info(resData.Msg || '发生网络错误')
          }
        }
      } catch (e) {
        console.log('error：' + response.data.data + '---' + e)
      }
    } else {
      if (response.config.bizCodeHandler) {
        return response
      }
    //   else {
    //     console.log(response.config, 'response.configresponse.config')
    //     if (response.config.isShowStatusError) {
    //       Toast.info(response.data.err || response.data.errMsg || '发生网络错误')
    //     }
    //   }
    }
    return response
  },
  async error => {
    // 对响应错误做点什么
    // location.href = ErrorUrl
    return await Promise.reject(error)
  }
)

const request = async (obj: object) => {
  obj = setUploadImgToken(obj, token)
  console.log(obj, 'kkkk')
  return await new Promise((resolve, reject) => {
    Axios(obj)
      .then(res => {
        // 对响应数据做点什么
        if (
          res.config.bizCodeHandler &&
          res.config.bizCodes &&
          res.config.bizCodes.includes(res.data.status)
        ) {
          res.config.bizCodeHandler(res.data)
          resolve(res)
        } else if (
          res.data.success === false ||
          (res.data.status !== 200 && res.data.status !== 'OK')
        ) {
          if (obj.isShowStatusError) {
            Toast.info(res.data.err || res.data.errMsg || '发生网络错误')
          }
          apiResponseH5(res, obj)
          if (obj.showError) {
            // showError不设置 默认为true 跳转到网络错误组件
            setStorage('pathName', location.href)
            const errTimer = setTimeout(() => {
              clearTimeout(errTimer)
              location.href = ErrorUrl
            }, 2000)
          }
        }
        resolve(res)
      })
      .catch((err: any) => {
        console.log('request error:', err)
        // if (obj.showHttpError) {
        if (err && err.response && err.response.status >= 500) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          Toast.info('APP请求失败，请稍后再试')
        } else if (err && err.request) {
          Toast.info('网络不给力，请稍后再试')
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
        } else {
          Toast.info('网络不给力，请稍后再试')
        }
        // }
        reject(err)
        // toast(`请求发生异常:${err.message}`)
        // location.href = ErrorUrl
        apiResponseH5(
          err.response,
          obj,
          err && err.response ? err.response.status : 500,
          JSON.stringify(err.message)
        )

        // Toast.info(`请求发生异常:${err.message}`)
        // // location.href = ErrorUrl
        // apiResponseH5(err.response, obj, err.response ? err.response.status : 500, JSON.stringify(err.message))
        // reject(err)
      })
  })
}

export const GET = async (GETDefaults: any) => {
  GETDefaults.headers = GETDefaults.headers || {}
  GETDefaults.headers = {
    ...DEFAULT_HEAERS,
    ...GETDefaults.headers
  }
  const obj = {
    method: 'GET',
    showError: true,
    isSetToken: false,
    isShowStatusError: true,
    headers: {
      ...GETDefaults.headers
    }
  }

  const newObj = {
    ...obj,
    ...GETDefaults
  }
  return await request(newObj)
}

export const POST = async (POSTDefaults: any) => {
  POSTDefaults.headers = POSTDefaults.headers || {}
  POSTDefaults.headers = {
    ...DEFAULT_HEAERS,
    ...POSTDefaults.headers
  }
  const obj = {
    method: 'POST',
    showError: true,
    isSetToken: false,
    isShowStatusError: true,
    headers: {
      ...DEFAULT_HEAERS
    }
  }
  const newObj = {
    ...obj,
    ...POSTDefaults
  }
  return await request(newObj)
}
export const POSTFORM = async (POSTDefaults: any) => {
  const obj = {
    method: 'POST',
    showError: true,
    isSetToken: false,
    isShowStatusError: true,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Client-Id': 'iss_courier'
    }
  }
  const newObj = {
    ...obj,
    ...POSTDefaults
  }
  return await request(newObj)
}
export default Axios
